import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';
import ToolkitMixin from '@/app/mixins/toolkit/item';
import InvStrat from '@/app/constants/store/toolkit/inv-strat/inv-strat.json';

export default {
  name: 'inv-strat-get-started',
  mixins: [ToolkitMixin],
  data: () => ({
    defaults: _.cloneDeep(InvStrat),
  }),
  computed: {
    selection() {
      return this.getItem.selection;
    },
    selectedStrat() {
      return InvStrat.filter(strat => strat.name === this.selection)[0] || { id: undefined };
    },
  },
  methods: {
    selectStrat(id) {
      const newSelection = InvStrat.filter(strat => strat.id === id)[0];
      this.$store.dispatch('toolkit/updateItemKey', { rule: 'SELECTION', data: { selection: newSelection } });
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
  validations: {
    selection: {
      required,
    },
  },
};
